import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputContato = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { contato } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("contato")
    }

    return (
        <CampoInputTexto
            id="inputContato"
            titulo="Nome contato estabelecimento"
            onChange={handleChange}
            name="contato"
            value={contato}
            disabled={disabled}
            >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputContato
